import { render } from "./ImportPopup.vue?vue&type=template&id=34627c5c&scoped=true"
import script from "./ImportPopup.vue?vue&type=script&lang=js"
export * from "./ImportPopup.vue?vue&type=script&lang=js"

import "./ImportPopup.vue?vue&type=style&index=0&id=34627c5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34627c5c"]])

export default __exports__